import React from "react";
import { useAuth } from "@/context/AuthContext";
import { ShieldOff } from "lucide-react";

export default function NoWorkspacePage() {
  const { principal, roleName } = useAuth();
  return (
    <div className="min-h-full flex items-center justify-center px-10 py-16">
      <div className="max-w-md text-center" data-testid="no-workspace">
        <div className="w-14 h-14 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/5 mx-auto flex items-center justify-center mb-6">
          <ShieldOff className="w-6 h-6 text-[#d4af37]" strokeWidth={1.5}/>
        </div>
        <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#d4af37] mb-2">Signed in</p>
        <h1 className="font-display text-3xl text-white mb-3">No workspace assigned</h1>
        <p className="text-sm text-gray-400 leading-relaxed">
          Welcome, {principal?.name}. Your role <span className="text-[#d4af37]">{roleName}</span> doesn&apos;t have a dedicated dashboard yet.
          The corresponding module will be enabled in a future phase.
        </p>
        <p className="text-xs text-gray-600 font-mono mt-6">If you need immediate access, please contact your Administrator.</p>
      </div>
    </div>
  );
}
